import { Button } from '@/components/ui/button';
import { useActiveOrganization } from '@/features/organization';
import { useSession } from '@/lib/session';
import { useQuery } from '@tanstack/react-query';
import { pendingDeletionQuery } from './pending-deletion-query';

export function OrganizationDeletion() {
  const { data: organization } = useActiveOrganization();
  const { data: session } = useSession();
  const canDelete =
    session?.user?.orgRole === 'owner' &&
    session.user.organizationId === organization?.id;
  const capabilities = useQuery({
    ...pendingDeletionQuery(session?.user?.id ?? ''),
    enabled: !!session?.user?.id && canDelete,
  });
  if (
    !canDelete ||
    capabilities.data?.pending !== false ||
    !capabilities.data.deletionAvailable
  )
    return null;
  return (
    <section className="space-y-3 border-t pt-6">
      <h2 className="font-semibold">Delete account</h2>
      <p className="text-sm text-muted-foreground">
        Delete the whole clinic workspace and its data. Only the clinic owner
        can do this.
      </p>
      <Button variant="destructive" asChild>
        <a href="/dashboard/settings/delete-account">Delete account</a>
      </Button>
    </section>
  );
}
